import { render, staticRenderFns } from "./CorporateSideTabs.vue?vue&type=template&id=c15c865c&scoped=true&"
import script from "./CorporateSideTabs.vue?vue&type=script&lang=ts&"
export * from "./CorporateSideTabs.vue?vue&type=script&lang=ts&"
import style0 from "./CorporateSideTabs.vue?vue&type=style&index=0&id=c15c865c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15c865c",
  null
  
)

export default component.exports